function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavigationContext, useScrollToTop } from "@react-navigation/native";
import * as Sentry from "@sentry/core";
import noop from "lodash/noop";
import { createContext, useContext, useEffect, useRef } from "react";
import { Platform, StyleSheet } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-controller";
import { useAnimatedRef, useScrollViewOffset } from "react-native-reanimated";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { View } from "./View";
export var ScrollViewContext = /*#__PURE__*/ createContext({
    scrollTo: noop,
    scrollToElement: noop
});
/**
 * @nosync
 */ export function ScrollToTop(props) {
    var scrollTo = useContext(ScrollViewContext).scrollTo;
    useEffect(function() {
        scrollTo({
            y: 0,
            animated: props.animated
        });
    }, [
        scrollTo,
        props.animated
    ]);
    return null;
}
/**
 * @nosync
 */ export function ScrollHere(props) {
    var ref = useRef(null);
    var scrollToElement = useContext(ScrollViewContext).scrollToElement;
    var insets = useSafeAreaInsets();
    useEffect(function() {
        if (ref.current) {
            var timeout = scrollToElement(ref.current, {
                getScrollPosition: function(parentLayout, childLayout, contentOffset) {
                    var _props_offsetY, _ref, _props_animated;
                    return {
                        x: 0,
                        y: Math.max(0, childLayout.y - parentLayout.y - insets.top - ((_ref = (_props_offsetY = props.offsetY) !== null && _props_offsetY !== void 0 ? _props_offsetY : contentOffset.y) !== null && _ref !== void 0 ? _ref : 0)),
                        animated: (_props_animated = props.animated) !== null && _props_animated !== void 0 ? _props_animated : true
                    };
                }
            });
            return function() {
                return clearTimeout(timeout);
            };
        }
        return;
    }, [
        scrollToElement,
        props.animated,
        props.offsetY,
        insets.top
    ]);
    // NB android requires size + backgroundColor to measure the layout properly
    return /*#__PURE__*/ _jsx(View, {
        ref: ref,
        style: {
            width: '100%',
            height: 1,
            backgroundColor: 'transparent',
            marginBottom: -1
        }
    });
}
/**
 * useScrollToTop is not typically safe to use outside of a ReactNavigation tree. However,
 * we do make use of our ScrollView in some situtations where we may not
 * be inside the navigation tree.
 * e.g. Reauthenticate / AppError rendered from AppContainer
 */ var useScrollToTopSafe = function(ref) {
    var context = useContext(NavigationContext);
    if (Platform.OS === 'web' || !context) return;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useScrollToTop(ref);
};
var useSafeAreaInsetsSafe = function() {
    if (Platform.OS === 'web') return {
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useSafeAreaInsets();
};
function measureInWindowAsync(view) {
    return new Promise(function(res) {
        view.measureInWindow(function(x, y, width, height) {
            res({
                x: x,
                y: y,
                width: width,
                height: height
            });
        });
    });
}
/**
 * A scrollable view element that allows rendering more content than fits on
 * the device screen at once.
 *
 * `ScrollHere` and `ScrollToTop` components can help manage the `ScrollView`
 * scroll position from within a child component.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-122}
 */ export function ScrollView(_param) {
    var topOverflowColor = _param.topOverflowColor, bottomOverflowColor = _param.bottomOverflowColor, disableBottomSafeAreaInset = _param.disableBottomSafeAreaInset, props = _object_without_properties(_param, [
        "topOverflowColor",
        "bottomOverflowColor",
        "disableBottomSafeAreaInset"
    ]);
    var scrollViewAnimatedRef = useAnimatedRef();
    var ref = useRef(null);
    var position = useScrollViewOffset(scrollViewAnimatedRef);
    var timeout = useRef(0);
    var insets = useSafeAreaInsetsSafe();
    var valueRef = useRef({
        scrollTo: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _ref_current;
            var _ref_current1;
            (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : (_ref_current = _ref_current1).scrollTo.apply(_ref_current, _to_consumable_array(args));
        },
        scrollToElement: function(el, options) {
            clearTimeout(timeout.current);
            timeout.current = setTimeout(function() {
                var scroll = function scroll() {
                    return _scroll.apply(this, arguments);
                };
                function _scroll() {
                    _scroll = _async_to_generator(function() {
                        var _options_getScrollPosition, scrollMeasure, elMeasure, scrollPosition;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(ref.current && el)) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        measureInWindowAsync(ref.current)
                                    ];
                                case 1:
                                    scrollMeasure = _state.sent();
                                    return [
                                        4,
                                        measureInWindowAsync(el)
                                    ];
                                case 2:
                                    elMeasure = _state.sent();
                                    scrollPosition = (options === null || options === void 0 ? void 0 : (_options_getScrollPosition = options.getScrollPosition) === null || _options_getScrollPosition === void 0 ? void 0 : _options_getScrollPosition.call(options, scrollMeasure, elMeasure, props.horizontal ? {
                                        x: position.value,
                                        y: 0
                                    } : {
                                        x: 0,
                                        y: position.value
                                    })) || {
                                        x: 0,
                                        y: Math.max(0, elMeasure.y - scrollMeasure.y + position.value),
                                        animated: true
                                    };
                                    ref.current.scrollTo(scrollPosition);
                                    _state.label = 3;
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _scroll.apply(this, arguments);
                }
                scroll().catch(Sentry.captureException);
            }, 200);
            return timeout.current;
        }
    });
    useScrollToTopSafe(ref);
    // ScrollViews typically extend to the bottom of the screen where navigation
    // UI is. This logic ensures we always have sufficient padding to avoid being covered by that UI
    var flatStyle = StyleSheet.flatten(props.contentContainerStyle) || {};
    var _flatStyle_paddingBottom, _ref, _ref1;
    var providedPaddingBottom = (_ref1 = (_ref = (_flatStyle_paddingBottom = flatStyle.paddingBottom) !== null && _flatStyle_paddingBottom !== void 0 ? _flatStyle_paddingBottom : flatStyle.paddingVertical) !== null && _ref !== void 0 ? _ref : flatStyle.padding) !== null && _ref1 !== void 0 ? _ref1 : 0;
    var bottomInset = disableBottomSafeAreaInset ? 0 : insets.bottom;
    var paddingBottom = typeof providedPaddingBottom === 'number' ? bottomInset + providedPaddingBottom : bottomInset;
    return /*#__PURE__*/ _jsxs(ScrollViewContext.Provider, {
        value: valueRef.current,
        children: [
            topOverflowColor || bottomOverflowColor ? /*#__PURE__*/ _jsxs(View, {
                style: StyleSheet.absoluteFillObject,
                children: [
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            flex: 1,
                            backgroundColor: topOverflowColor || 'transparent'
                        }
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            flex: 1,
                            backgroundColor: bottomOverflowColor || 'transparent'
                        }
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(KeyboardAwareScrollView, _object_spread_props(_object_spread({
                ref: function(r) {
                    ref.current = r;
                    // @ts-expect-error types aren't correct this is valid
                    scrollViewAnimatedRef(r || undefined);
                },
                // hide scroll indicators in e2e tests for image snapshot stability
                showsHorizontalScrollIndicator: !global.e2e,
                showsVerticalScrollIndicator: !global.e2e,
                scrollIndicatorInsets: props.horizontal !== false ? {
                    right: Number.MIN_VALUE
                } : undefined,
                // give extra padding / cushion so inputs aren't crammed against the keyboard
                bottomOffset: 200
            }, props), {
                contentContainerStyle: [
                    props.contentContainerStyle,
                    {
                        paddingBottom: paddingBottom
                    }
                ],
                keyboardShouldPersistTaps: "handled"
            }))
        ]
    });
}
